export const parseQueryParamValue = (value: string | string[] | undefined): string[] => {
  if (!value) {
    return [];
  }

  const stringValue = Array.isArray(value) ? value.join(',') : value;
  return stringValue.split(',').filter(Boolean);
};

export const getQueryParamAsString = (value: string | string[] | undefined): string => {
  if (!value) {
    return '';
  }

  return Array.isArray(value) ? value.join(',') : value;
};
